export default "__VITE_ASSET__812cbdc5__"